import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { GooglePlaceChainBase, LodgingChain } from 'models/google_place_chain'
import { getGooglePlaceBaseColumns } from '../GooglePlaceBase/GooglePlaceBaseColumnsInfo'

export const LODGING_COLUMNS = getGooglePlaceBaseColumns(
  'Lodging'
) satisfies Partial<
  Record<keyof GooglePlaceChainBase | keyof LodgingChain, DataTypeColumn>
>
